import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'task-tags/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_TASK_TAGS_REQUEST,
                        types.SEARCH_TASK_TAGS_SUCCESS,
                        types.SEARCH_TASK_TAGS_FAILURE
                    ]
                }
            });
        },
    saveTag: (taskTag) =>
        (dispatch) => {
            if (taskTag.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'task-tags/create',
                        method: 'POST',
                        body: taskTag,
                        types: [
                            types.CREATE_TASK_TAG_REQUEST,
                            types.CREATE_TASK_TAG_SUCCESS,
                            types.CREATE_TASK_TAG_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'task-tags/update',
                        method: 'PUT',
                        body: taskTag,
                        types: [
                            types.UPDATE_TASK_TAG_REQUEST,
                            types.UPDATE_TASK_TAG_SUCCESS,
                            types.UPDATE_TASK_TAG_FAILURE
                        ]
                    }
                });
            }
        } 
}